import { lazy } from 'react';

export const PartnerNamePageLazy = lazy(() => import('./partner-name'));
